const crypto = require("crypto-js");
const algorithm = "aes-256-ctr";
const secretKey = "vOVH6sdmpNWjRRIqCc7rdxs01lwHzfr3";
const iv = "80e2af0a60ecbd16618abc72c2d00fb3";

// encrypt url parameter
export const apsisEncrypt = (url) => {
  const cipher = crypto.AES.encrypt(url, secretKey);

  return cipher.toString();
};

// decrypt url paramter
export const apsisDecrypt = (url) => {
  const decipher = crypto.AES.decrypt(url, secretKey);

  const decrpyted = decipher.toString(crypto.enc.Utf8);

  if (!decrpyted) {
    return null;
  }

  return decrpyted.toString();
};
